import React from "react";
import { useTranslation } from "react-i18next";
import mailIcon from "../../assets/images/icon/mail.svg";
import ManOne from "../../assets/images/banner/banner-main.webp";
import { Link } from "react-router-dom"; // Make sure to import Link

const Banner = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="xl:min-h-screen bg-[url('../images/banner/1.png')] bg-cover bg-no-repeat bg-center overflow-hidden">
      <div className="container relative">
        <div
          className={`max-w-[570px] xl:pt-[297px] sm:pt-[13rem] md:pt-20 banner-text md:pb-20 pt-28 pb-14 xl:pb-40 space-y-8`}
        >
          {/* Heading */}
          <h1>
            {t("banner.title").split(" ")[0]}{" "}
            <span className=" text-secondary inline-block bg-[url('../images/banner/shape.svg')] bg-no-repeat bg-bottom">
              {t("banner.highlight")}
            </span>{" "}
            {t("banner.title").split(" ").slice(1).join(" ")}
          </h1>

          {/* Description */}
          <div className="plain-text text-gray leading-[30px]">
            {t("banner.description")}
          </div>

          {/* ✅ CTA Button */}
          <div>
            <Link
              to="/contacts" // Change this path as needed
              className="btn btn-primary inline-flex items-center gap-2 px-8 py-4 text-lg font-semibold rounded transition hover:shadow-lg"
            >
              {/* <img src={mailIcon} alt="mail" className="w-5 h-5 " /> */}
              {t("banner.cta_button")} {/* Add this key in translation file */}
            </Link>
          </div>
        </div>

        {/* Hero Image */}
        <div
          className={`imge-box absolute ${
            i18n.language === "en" ? " banner-img" : "banner-img-rtl"
          } hidden xl:block bottom-0`}
        >
          <img src={ManOne} alt="manOne" />
        </div>
      </div>
    </section>
  );
};

export default Banner;
